import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: any;

  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  async loadConfig() {
    //Comment out the below line to test specific page with auto redirection to home
    // Don't redirect to home if user is in playground mode or on specific routes
    const currentUrl = window.location.href;
    const isPlaygroundRoute = currentUrl.toLowerCase().includes('playground');
    const isMaintenanceRoute = currentUrl.toLowerCase().includes('maintenance');

    if (!isPlaygroundRoute && !isMaintenanceRoute) {
      const queryParams = currentUrl.includes('?')
        ? currentUrl.split('?')[1] || ''
        : '';
      this.router.navigateByUrl(`/?${queryParams}`);
    }

    this.config = await lastValueFrom(this.http.get('assets/config.json'));
  }

  getConfig(): any {
    /*
    let url = window.location.href;

    let requestBaseUrlSuffix = `dev`;
    if (
      url.includes('dev-') ||
      url.includes('dev.') ||
      url.includes('localhost')
    ) {
    } else if (url.includes('qa-') || url.includes('qa.')) {
      requestBaseUrlSuffix = `qa`;
    } else if (url.includes('uat-') || url.includes('uat.')) {
      requestBaseUrlSuffix = `uat`;
    } else {
      requestBaseUrlSuffix = `prod`;
    }

    return {
      requestBaseUrl: `https://${requestBaseUrlSuffix}-dgsn-sbms.digisign.npuwapp.us-east-1.aws.aig.net`,
      pdfBaseUrl: `https://${requestBaseUrlSuffix}-dgsn-pdfcr.digisign.npuwapp.us-east-1.aws.aig.net`,
    };
*/
    return this.config;
  }
}
